<c-container class="min-vh-90">
    <app-header-user></app-header-user>
    <div>
        <c-card class="card-no-border account-card">
            <c-card-body>
                <iframe class="framer-full" [src]="url|safe " allowfullscreen></iframe>
            </c-card-body>
        </c-card>
    </div>
</c-container>